<template>
  <b-dropdown
    :triggers="['hover']"
    aria-role="list"
    position="is-bottom-left"
    v-if="tefFailure"
  >
    <template #trigger>
      <b-icon
        icon="exclamation-triangle"
        size="is-small"
        type="is-danger"
        pack="fas"
        class="error-icon"
      ></b-icon>
    </template>

    <b-dropdown-item
      aria-role="listitem"
      class="error-description"
      @click="copyContent(tefFailureText, $t('transactions.tefErrorCopied'))"
    >
      <template v-if="tefFailure.code">
        <b>{{ $t("transactions.tefErrorCode") }}: </b>
        {{ tefFailure.code }}
        <br />
      </template>
      <b>
        {{
          tefFailure.fromAuthorizer
            ? $t("transactions.tefAuthorizerResponse")
            : $t("transactions.response")
        }}:
      </b>
      {{ tefFailure.message }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { common } from "../../../mixins/common";
import { getTransactionTefFailure } from "../../../utils/tefResponse";

export default {
  props: ["t"],

  mixins: [common],

  computed: {
    // Venda TEF que falhou (negada, erro de SiTef/pinpad...). Ela chega com
    // status "cancelled", por isso o erro so aparece aqui e no hover do status.
    tefFailure() {
      return getTransactionTefFailure(this.t);
    },

    tefFailureText() {
      if (!this.tefFailure) return "";

      return this.tefFailure.code
        ? `[${this.tefFailure.code}] ${this.tefFailure.message}`
        : this.tefFailure.message;
    }
  }
};
</script>

<style scoped>
.error-icon {
  cursor: pointer;
}

/* O item do dropdown nao quebra linha por padrao; mensagens longas do
   CliSiTef ficavam numa linha so */
.error-description {
  white-space: normal;
  min-width: 20rem;
  max-width: 28rem;
  overflow-wrap: anywhere;
}
</style>
